/** @jsx jsx */
import { type ReactNode, memo, useRef } from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useResizeObserver } from '@atlassian/jira-react-use-resize-observer/src/index.tsx';

const PopupContentComponent = ({
	children,
	update,
}: {
	children: ReactNode;
	update: () => void;
}) => {
	const componentRef = useRef(null);

	useResizeObserver({
		ref: componentRef,
		onResize: update,
	});

	return (
		<div
			css={popoverStyles}
			ref={componentRef}
			data-testid="hover-popover.ui.popup-content.hover-popover-content"
			aria-hidden="true"
		>
			{children}
		</div>
	);
};

export const PopupContent = memo(PopupContentComponent);

const popoverStyles = css({
	backgroundColor: token('elevation.surface.overlay'),
	paddingInline: token('space.150'),
	paddingBlock: token('space.075'),
	borderRadius: token('border.radius'),
	boxShadow: token('elevation.shadow.overlay'),
	fontBody: token('font.body'),
	fontWeight: token('font.weight.regular'),
	overflowWrap: 'break-word',
	maxHeight: '300px',
	wordBreak: 'break-word',
	overflow: 'auto',
});
